import React, { Component, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Card, Typography, Divider, CardContent, CardHeader, Container, Box, Tooltip } from "@material-ui/core";
import cardlogo from '../../../assets/img/svg/ShipCard.svg';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from "@material-ui/icons/Delete"
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import filterIcon from '../../../assets/img/svg/FilterIcon.svg';
import { useNavigate } from "react-router-dom";
import FilterIcon from '../../../assets/img/svg/FilterIcon.svg';
import Autocomplete from "react-autocomplete";
import moment from "moment";
import axios from "axios";
import API from "../../../_helpers/endpointService";
import $ from "jquery"
import { getlookupdocinfo } from "../../../actions/MasterDataAction";
import { getProjectNames, getProjects } from "../../../actions/projectAction";
import { getprojectbasicinfo } from "../../../actions/AddNewProjectAction";
import { withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../assets/jss/customStyle";
import withRouter from "../../custom/withRouter";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

class ProjectListview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            isEdit: false,
            search: false,
            UserRole: "",
            menu: true,
            NamesProject: [],
            Projects: [],
            open: true,
            searchData: {
                UserEmail: "",
                Name: "",
                Status: "In Progress",
                PageNumber: 1,
                PageSize: 100
            },

        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.searchData.UserEmail = JSON.parse(localStorage.getItem("currentUser")).email;
        this.setState({})
        dispatch(getlookupdocinfo("Status"))
        dispatch(getProjects(this.state.searchData))
        this.getProjectList();
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
        // this.interval = setInterval(() => {
        //     this.resize()
        // }, 10);
        localStorage.removeItem("DashId")
        localStorage.removeItem("addeditid")
        localStorage.removeItem("ProjectName")
        // localStorage.removeItem("ProjectStartDate")
        // localStorage.removeItem("EstimatedCompletionDate")
        // localStorage.removeItem("ExtensionDate")
        // localStorage.removeItem("ProjectCompletionDate")
        // localStorage.removeItem("ProjectStatus")
        localStorage.removeItem("YardId")
        localStorage.removeItem("YardTraining")
        localStorage.removeItem("BasicInfo")
        $("#PROJ1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Projects1 .MuiListItemText-primary").addClass("fw-bolder")
        $("#Projects").removeClass("d-none")
        $("#Projects").addClass("d-block")
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
    }

    sidebar = () => {
        if (this.state.isEdit == 'true') {
            this.props.navigate("/sidebareditproject");
        }
        else {
            this.props.navigate("/sidebaraddproject");
        }

    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        // this.props.dispatch(getlookupdocinfo("Status"))
    };

    resize1 = () => {
        $("#PROJ1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Projects1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Projects").removeClass("d-none");
        $("#Projects").addClass("d-block");
    }

    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate(
            `/basicinformation/add`
        );
    };

    EditPage = (e, item) => {
        this.props.dispatch({ type: "CANCEL", data: false });
        localStorage.removeItem("DashId")
        localStorage.setItem("DashId", e)
        localStorage.setItem("YardId", item?.YardId)
        // localStorage.setItem("ProjectStartDate", moment(item?.ProjectStartDate).format("yyyy-MM-DD"))
        // localStorage.setItem("EstimatedCompletionDate", moment(item?.EstimatedCompletionDate).format("yyyy-MM-DD"))
        // localStorage.setItem("ExtensionDate",  moment(item?.ExtensionDate).format("yyyy-MM-DD"))
        // localStorage.setItem("ProjectCompletionDate",  moment(item?.ProjectCompletionDate).format("yyyy-MM-DD"))
        // localStorage.setItem("ProjectStatus", JSON.stringify(item?.Status))
        this.props.dispatch(getprojectbasicinfo(e))
        this.props.navigate(
            `/basicinformation/edit`
        );
    };


    handleAnnualSelectChange = (e) => {
        this.state.searchData.Status = e;
        this.setState({});
    };
    ProjectStatusSelectChange(e) {
        this.state.search = true
        this.state.searchData.Status = e.target.value;
        this.setState({});
    }
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSearchChange = (e) => {
        this.state.searchData.Name = e.target.value;
        this.setState({});
    };
    handleProjectNameSelectChange = (e) => {
        this.state.searchData.Name = e;
        this.setState({});
    };
    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            UserEmail: JSON.parse(localStorage.getItem("currentUser")).email,
            Name: "",
            Status: "In Progress",
            PageNumber: 1,
            PageSize: 100
        };
        this.state.searchData = input;
        this.setState({});
        // dispatch(getProjects(this.state.searchData))
    }
    filterSearch() {
        this.state.search = true;
        const { dispatch } = this.props;
        if (this.state.searchData.Status === "" && this.state.searchData.Name == "") {
            this.state.searchData.Status = "In Progress"
        }
        dispatch(getProjects(this.state.searchData))
    }
    getProjectList = () => {
        let apiUrl = API.ADDEDIT_PROJECT + 'ProjectList';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data?.length > 0) {
                        this.state.Projects = response.data;
                        this.setState({})
                    }
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    DashboardNavigation(e, item) {
        localStorage.setItem("DashId", e)
        localStorage.setItem("YardId", item?.YardId)
        // localStorage.setItem("ProjectStartDate", moment(item?.ProjectStartDate).format("yyyy-MM-DD"))
        // localStorage.setItem("EstimatedCompletionDate", moment(item?.EstimatedCompletionDate).format("yyyy-MM-DD"))
        // localStorage.setItem("ExtensionDate",  moment(item?.ExtensionDate).format("yyyy-MM-DD") != "0001-01-01" ? moment(item?.ExtensionDate).format("yyyy-MM-DD") : null)
        // localStorage.setItem("ProjectCompletionDate",  item?.ProjectCompletionDate && moment(item?.ProjectCompletionDate).format("yyyy-MM-DD"))
        // localStorage.setItem("ProjectStatus", item?.Status)
        this.props.dispatch(getprojectbasicinfo(e))
        this.props.navigate(`/dashboard`)
    }

    render() {
        const { isEdit } = this.state;
        let { Lookup_data, classes, projectList, projectNames, menuToggle } = this.props;
        return (<>
            {
                this.state.isMobile ?
                    <>
                        <div className="row w-100 mt-4 mob-topfixed">
                            <div className="col-6">
                                <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem >
                                        <ListItemText id={"PROJ" + "1"} className=' textNaviIcon' primary="Projects" />
                                        <NavigateNextIcon id="PROJ" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-6 pt-2 mt-5">
                                <h4 className="pt-2">Active Projects</h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
            }
            <div className=" ml-auto" style={{ backgroundColor: "#FFFFFF", width: "100%", marginTop: this.state.isMobile ? '' : -95 }}>
                {
                    this.state.isMobile ? <>
                        {this.state.UserRole && this.state.UserRole == "Admin" ?
                            <table className={`dataTable border-top mob-table-fixed `} width="100%">
                                <tbody>
                                    <tr>
                                        <td>
                                            <button className={`${classes.button} pl-3`} onClick={() => this.AddNew()}><i className="fa fa-plus pr-2" style={{ color: "#00838F" }}></i>Add New Project</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table> : <></>}</>
                        :
                        <>
                            {this.state.UserRole && this.state.UserRole == "Admin" ?
                                <table className={`dataTable ${window.innerWidth >= 850 ? " table-fixed" : ""}`} width="100%" style={{ backgroundColor: "white" }}>
                                    <tbody>
                                        <tr>
                                            <td width="100%" className="">
                                                <button className={`${classes.button} pl-4 ml-2`} onClick={() => this.AddNew()}><i className="fa fa-plus pr-2" style={{ color: "#00838F" }}></i>Add New Project</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> : <></>} </>}
                <Container className={`${window.innerWidth >= 850 ? " top-fixed" : ""}`} maxWidth="false" style={{ paddingLeft: 40, paddingRight: 40, backgroundColor: "white", marginTop: this.state.isMobile ? 172 : '' }}>
                    <Grid container spacing={3} className="mt-2">
                        <Grid item xs={12} md={12} lg={12}>
                            <div className="row">
                                <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                    {this.state.isMobile ? <></> : <h6 className="col-12" style={{ marginLeft: -10 }}>Active Projects</h6>}
                                </div>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-end m-auto">
                                    {/* <img src={filterIcon}></img> */}
                                    <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`}><img src={FilterIcon} />&nbsp;Filter </button>

                                    {/* <span onClick={() => }>&nbsp;&nbsp;Filter</span> */}
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} className={window.innerWidth < 1280 ? "d-flex container-lg mx-lg-auto" : ""}>
                        {/*&& projectList.value && projectList.value.*/}
                        {projectList && projectList?.Project && projectList?.Project.map((item, index) => (
                            <>
                                <Grid className={classes.gridItem} item xs={12} sm={6} md={6} lg={3} xl={3}>
                                    <Card className={classes.card} style={{ backgroundColor: "#00838F", color: "#FFFFFF" }}>
                                        <CardContent className={classes.cardContent}>
                                            <div className="row cursorPointer" onClick={() => this.DashboardNavigation(item?.ProjectId, item)}>
                                                <div className="col-sm-12 col-12 fw-normal overflow fw-bold f-size-14">{item?.ProjectName}</div>
                                            </div>

                                            <Divider className="mt-2" style={{ backgroundColor: "#212121e3" }} />
                                            <Box display={'flex'} mt={1} mb={0} className="row cursorPointer " style={{ minHeight: '150px' }} onClick={() => this.DashboardNavigation(item?.ProjectId, item)}>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <Box color="" className="row mt-auto">
                                                        <p className="col-sm-5 col-6 col-md-6 col-lg-6 pr-0" style={{ color: "#f9f9f9eb" }}>Owner</p>
                                                        <p className="col-sm-7 col-6 col-md-6 col-lg-6 pl-1 fw-bold overflow">{item.ProjectUsers?.ShipOwnerName}</p>
                                                    </Box>
                                                    <Box color="" className="row mt-auto">
                                                        <p className="col-sm-5 col-6 col-md-6 col-lg-6 pr-0" style={{ color: "#f9f9f9eb" }}>Yard</p>
                                                        <p className="col-sm-7 col-6 col-md-6 col-lg-6 pl-1 overflow fw-bold">{item?.YardName}</p>
                                                    </Box>
                                                    <Box color="" className="row mt-auto">
                                                        <p className="col-sm-5 col-6 col-md-6 col-lg-6 pr-0" style={{ color: "#f9f9f9eb" }}>Start Date</p>
                                                        <p className="col-sm-7 col-6 col-md-6 col-lg-6 pl-1 fw-bold text-left word-break" >{item.ProjectStartDate && moment(item.ProjectStartDate).format("DD MMM YYYY")}<br></br></p>
                                                    </Box>
                                                    {item.Status == "Completed" ?
                                                        <Box color="" className="row mt-auto">
                                                            <p className="col-sm-5 col-6 col-md-6 col-lg-6 pr-0" style={{ color: "#f9f9f9eb" }}>Completed Date</p>
                                                            <p className="col-sm-7 col-6 col-md-6 col-lg-6 pl-1 fw-bold word-break">{item.ProjectCompletionDate && moment(item.ProjectCompletionDate).format("DD MMM YYYY")}<br></br></p>
                                                        </Box>
                                                        :
                                                        <Box color="" className="row mt-auto">
                                                            <p className="col-sm-5 col-6 col-md-6 col-lg-6 pr-0" style={{ color: "#f9f9f9eb" }}>Estimated Completion Date</p>
                                                            <p className="col-sm-7 col-6 col-md-6 col-lg-6 pl-1 fw-bold word-break">{item.EstimatedCompletionDate && moment(item.EstimatedCompletionDate).format("DD MMM YYYY")}<br></br></p>
                                                        </Box>}
                                                </div>
                                            </Box>
                                            <Divider className="mb-2" style={{ backgroundColor: "#212121e3" }} />
                                            <div className="row" style={{ height: '30px' }}>
                                                <div className="col-sm-10 col-10 text-left fw-bold ">{item?.Status}</div>
                                                {this.state.UserRole == "Admin" ? <>
                                                    <div className="col-sm-2 col-2 text-right">
                                                        <Tooltip title="Edit" placement="top" arrow>
                                                            <NavigateNextIcon className="float-end cursorPointer" onClick={() => this.EditPage(item?.ProjectId, item)} />
                                                        </Tooltip>
                                                    </div>
                                                </> : <></>}
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>

                            </>))}
                    </Grid>
                </Container>
            </div>
            <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                    <div className="modal-content border-radius">
                        <div className="modal-header">
                            <div className="row m-0">
                                <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                <div className="col-12">
                                    <span className="cursorPointer" onClick={() => this.ResetFilter()}>
                                        <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body p-4">
                            <form id="myform">
                                <div className="form-group row">
                                    <div className="col-5 m-auto">
                                        <label htmlFor="name">Project Name</label></div>
                                    <div className="col-7">
                                        <div className="autocomplete-wrappers">
                                            <Autocomplete
                                                contentEditable={true}
                                                value={this.state.searchData.Name}
                                                inputProps={{
                                                    placeholder: "Project Name",
                                                }}
                                                items={this.state.Projects ?? []}
                                                getItemValue={(item) => item.Name}
                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                renderMenu={(item) => (
                                                    <div className="dropdowns d-block" >{item}</div>
                                                )}
                                                renderInput={(props) => {
                                                    return (
                                                        <input
                                                            className="form-control border-radius"
                                                            id="exampleFormControlInput1"
                                                            {...props}
                                                            style={{ height: 32, fontSize: 12, color: "#000000" }}
                                                        />
                                                    );
                                                }}
                                                renderItem={(item, isHighlighted) => (
                                                    <div
                                                        className={`items 
                                                        ${isHighlighted ? "selected-items" : ""
                                                            }`}
                                                    >
                                                        {item.Name}
                                                    </div>
                                                )}
                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-5 m-auto">
                                        <label htmlFor="name">Project Status</label>
                                    </div>
                                    <div className="col-7 ">
                                        <select className="form-control border-radius"
                                            onChange={(e) => this.ProjectStatusSelectChange(e)}
                                            value={this.state.searchData.Status}
                                        >
                                            <option value="">Select Status</option>
                                            {this.props.Lookup_data.length > 0 &&
                                                this.props.Lookup_data.map((i) => (
                                                    i.Name != '' ? <option value={i.Name}>{i.Name}</option> : <></>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="row text-center mt-4">
                                    {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                    <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                        <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.filterSearch()}>Search</button>
                                    </div>
                                    <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                        <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        </>
        );
    };
};

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        projectStatus: state.projectReducer.projectStatus || [],
        Lookup_data: state.MasterDataReducer.Lookup_data || [],
        projectList: state.projectReducer.projectList || [],
        projectNames: state.projectReducer.projectNames || [],
    };
}

ProjectListview.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProjectListview))
);
